// Rotas públicas de movimentações financeiras (boleto/fatura/pix/pagamento/recibo).
// Migradas do submódulo f-erp-financeiro (repo f-erp-financeiro, movimentacoes/router/routes.js)
// para o build principal do f-erp, pois usam paths de raiz (/boleto/:hash, /fatura/:hash, etc.)
// e precisam responder mesmo sem o submódulo financeiro carregado. Apenas as rotas public:true.
const routes = [
    {
        name: 'linkFaturaDigitalMovimentacaoFinanceira',
        path: '/link-fatura/:hash',
        component: () => import('../components/Fatura'),
        meta: {
            fullScreen: true,
            public: true
        },
    },
    {
        name: 'linkReciboMovimentacaoFinanceira',
        path: '/recibo/:hash',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        },
    },
    {
        name: 'linkFaturaMovimentacaoFinanceira',
        path: '/fatura/:hash',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        },
    },
    {
        name: 'linkBoletoMovimentacaoFinanceira',
        path: '/boleto/:hash',
        component: () => import('../components/ImpressaoBoleto'),
        meta: {
            fullScreen: true,
            public: true
        },
    },
    {
        name: 'linkPixPagamentoMovimentacaoFinanceira',
        path: '/pix/:hash',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        },
    },
    {
        name: 'linkPagagamentoMovimentacaoFinanceira',
        path: '/pag/:hash',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        },
    },
    {
        name: 'linkPagagamentoMovimentacaoFinanceiraEnvio',
        path: '/pg/:hash',
        component: () => import('../components/ImpressaoBoleto'),
        meta: {
            fullScreen: true,
            public: true
        },
    },
    {
        name: 'imprimirBoletosMovimentacaoFinanceira',
        path: '/movimentacoes_financeiras/imprimir_boletos',
        component: () => import('../components/ImpressaoBoletos'),
        meta: {
            fullScreen: true,
            public: true
        },
    },
]

export default routes
